import Button from "components/Buttons/Button";
import { HowInstantPayWorksType } from "components/Tutorials/InstantPayTutorial.tsx/HowInstantPayWorks";
import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { paratext } from "styles";

interface ITutorialcardProps {
  card: HowInstantPayWorksType;
  selectedCardId: number;
}
const TutorialCard: React.FC<ITutorialcardProps> = ({
  card,
  selectedCardId,
}) => {
  return (
    <div
      className={`flex flex-col gap-4 items-center text-center md:min-w-[360px] min-w-[80vw] md:h-full border rounded-xl p-4 ${
        selectedCardId < card?.id
          ? "opacity-10"
          : selectedCardId > card?.id
          ? "opacity-60"
          : ""
      }`}
    >
      <div className="flex flex-col justify-between h-full w-full items-center gap-4">
        <div className="flex-1 flex flex-col items-center">
          <div>{card?.icon}</div>
          <div className="text-bold text-xl mt-4">{card?.title}</div>
          <div className={`${paratext} align-self-end mt-8`}>
            {card?.description}
          </div>
        </div>
        <div className="text-brightOrange text-xs align-self-end">
          <span className="font-bold">Tip : </span> {card?.note}
        </div>

        <Button
          label={
            <>
              {" "}
              {selectedCardId > card?.id ? (
                <div className="flex gap-2">
                  Understood
                  <FaCheckCircle className="text-lg text-white justify-end align-self-end flex" />
                  {/* <RiVerifiedBadgeFill className="text-xl text-white justify-end align-self-end flex" /> */}
                </div>
              ) : (
                "Next"
              )}
            </>
          }
          customClass={`md:w-[150px] !text-md w-[95%] !me-0 !rounded-md mt-auto  ${
            selectedCardId > card?.id ? "!bg-green cursor-not-allowed" : ""
          }`}
          disabled={false}
          onClick={
            selectedCardId !== card?.id
              ? () => {
                  return;
                }
              : card?.onNext
          }
        />
      </div>
    </div>
  );
};

export default TutorialCard;
